export default {
    baseStyle: {
        wrapper: {
            position: 'absolute',
            top: {base: '10px', lg: '20px'},
            paddingY: '10px',
            paddingX: '20px'
        },
        title: {
            display: 'flex',
            alignItems: 'center',
            fontSize: {base: '16px', lg: '24px'},
            letterSpacing: {base: '0.12px', lg: '0.12px'},
            lineHeight: 'normal',
            fontWeight: '400'
        },
        titleDollarSign: {
            width: {base: '9px', lg: '11px'},
            height: 'auto'
        }
    },
    variants: {
        promoGridFourItems: {
            wrapper: {
                paddingY: {base: '5px', xs: '10px'},
                paddingX: {base: '10px', xs: '20px'}
            },
            title: {
                fontSize: {base: '18px', xs: '24px'},
                letterSpacing: {base: '0.12px', xs: '0.12px'}
            }
        }
    },
    parts: ['wrapper', 'title'],
    defaultProps: {
        variant: 'default'
    }
}
